module.exports = __webpack_public_path__ + "static/media/Bg-faq-auto.3549d057.svg";